import { Plus } from 'assets/icons';
import { generateEmployeeColor } from 'helper/helper';

// An employee's initials on the colour of their name, as on the mission
// cards; nobody, a dashed circle with a plus. The initials follow the size:
// 10 px on the 24 px avatar, never less.
const EmployeeAvatar = ({ employee, size = 24 }) => {
  const style = { width: size, height: size };
  const fontSize = Math.max(10, Math.round((size * 10) / 24));
  if (!employee) {
    return (
      <span
        className="flex shrink-0 items-center justify-center rounded-full text-gray-700 outline-dashed outline-gray-300"
        style={style}
      >
        <Plus wh={16} color="currentColor" />
      </span>
    );
  }
  return (
    <span
      className="flex shrink-0 items-center justify-center rounded-full text-white"
      style={{ ...style, fontSize, backgroundColor: generateEmployeeColor(employee.firstname, employee.lastname) }}
    >
      {`${employee.firstname?.charAt(0).toUpperCase() ?? ''}${employee.lastname?.charAt(0).toUpperCase() ?? ''}`}
    </span>
  );
};

export default EmployeeAvatar;
